import React from 'react'
import { BottomNavigation } from '@material-ui/core';

const ActionBar = ({children}) => {

  return (
    <BottomNavigation>
      {children}
    </BottomNavigation>
  )
}

export default ActionBar